import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Instrument_Serif%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22variable%22:%22--font-v7-serif%22,%22weight%22:%22400%22,%22style%22:[%22italic%22],%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22Georgia%22,%22serif%22]}],%22variableName%22:%22instrumentSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Instrument Serif', Georgia, serif",
        fontWeight: 400,
fontStyle: "italic",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
